// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  Divider,
  Button,
  DialogContentText,
  Table,
  TableRow,
  TableCell,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios.js";
import usePageTitle from "app/pageTitle";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";

import AppConfig from "appConfig";
import Editor from "react-simple-wysiwyg";

function RecipientGroupViewPage() {
  const pageTitle = "Audience Groups";
  usePageTitle(pageTitle);
  const navigate = useNavigate();
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [openMessageDialog, setOpenMessageDialog] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);

  const [audienceGroup, setAudienceGroup] = useState(null);
  const [recipients, setRecipients] = useState([]);
  const [uploadFile, setUploadFile] = useState(null);
  const [openUploadAgentsDialog, setOpenUploadAgentsDialog] = useState(false);

  const [title, setTitle] = useState(null);
  const [subject, setSubject] = useState(null);
  const [messageBody, setMessageBody] = useState(null);
  const [senderName, setSenderName] = useState(null);
  const [scheduled, setScheduled] = useState(false);
  const [triggerDate, setTriggerDate] = useState(null);
  const [triggerTime, setTriggerTime] = useState(null);

  const [selectedRecipient, setSelectedRecipient] = useState(null);

  function generateTimeArray() {
    const startTime = new Date();
    const endTime = new Date();
    startTime.setHours(0, 0, 0, 0);
    endTime.setHours(23, 59, 0, 0);

    const timeArray = [];
    const currentTime = new Date(startTime);

    while (currentTime <= endTime) {
      const hours = String(currentTime.getHours()).padStart(2, "0");
      const minutes = String(currentTime.getMinutes()).padStart(2, "0");
      timeArray.push(`${hours}:${minutes}`);
      currentTime.setMinutes(currentTime.getMinutes() + 30);
    }

    return timeArray;
  }

  const timeArray = generateTimeArray();

  const tableColumns = [
    { Header: "Recipient", accessor: "recipient", align: "left" },
    // { Header: "Attributes", accessor: "attr", align: "left" },
    { Header: "Action", accessor: "action", align: "right" },
  ];

  const buildRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        recipient: row.recipient,
        // attr: row.attribute,
        action: (
          <>
            <Tooltip title="View More">
              <MDButton
                size="small"
                variant="outlined"
                color="info"
                iconOnly
                onClick={() => {
                  setSelectedRecipient(row);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  visibility
                </Icon>
              </MDButton>
            </Tooltip>
            {/* &nbsp;
            <Tooltip title="Delete">
              <MDButton
                size="small"
                variant="outlined"
                color="error"
                iconOnly
                onClick={() => {
                  if (window.confirm(`Remove ${row.title}?`) === true) {
                    // deleteCustomField(row.reference);
                  }
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  delete
                </Icon>
              </MDButton>
            </Tooltip> */}
          </>
        ),
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/messaging/groups/${ref}/fetch.json`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setAudienceGroup(result.data.data.group);
            const rows = buildRows(result.data.data.recipients);
            setRecipients(rows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function sendMessage() {
    if (audienceGroup.messaging_type === "EMAIL") {
      if (subject === null) {
        setSeverity("error");
        setErrMsg("Subject is required");
        setOpen(true);
        return;
      }
    }

    if (messageBody === null) {
      setSeverity("error");
      setErrMsg("Message body is required");
      setOpen(true);
      return;
    }

    let unixTimestampInSeconds = Math.floor(Date.now() / 1000);
    if (scheduled) {
      if (triggerDate === null) {
        setSeverity("error");
        setErrMsg("Scheduled date is required");
        setOpen(true);
        return;
      }
      if (triggerTime === null) {
        setSeverity("error");
        setErrMsg("Scheduled time is required");
        setOpen(true);
        return;
      }
      const dateString = `${triggerDate} ${triggerTime}:00`;
      const timestampInSeconds = Math.floor(new Date(dateString).getTime() / 1000);
      if (unixTimestampInSeconds > timestampInSeconds) {
        setSeverity("error");
        setErrMsg("Schedule must be in the future.");
        setOpen(true);
        return;
      }
      unixTimestampInSeconds = timestampInSeconds;
    }

    setOpenMessageDialog(false);
    setShowLoading(true);

    const json = {
      reference: ref,
      subject: `${subject}`,
      message_body: messageBody,
      title: `${title}`,
      send_time: unixTimestampInSeconds,
      sender: senderName,
    };

    await axios
      .post("portal/messaging/groups/broadcast.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  function fileSelected(e) {
    e.persist();
    const fileTypes = ["xlsx", "xls", "csv"];
    const file = e.target.files[0];
    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.indexOf(extension) > -1;
    if (!supported) {
      setSeverity("error");
      setErrMsg("Only excel and csv files accepted.");
      setOpen(true);
      return;
    }
    setUploadFile(e.target.files[0]);
  }

  const uploadRecipients = async () => {
    if (!uploadFile) {
      return;
    }
    const formData = new FormData();
    formData.append("reference", ref);
    formData.append("file", uploadFile);

    // console.log(formData)
    setOpenUploadAgentsDialog(false);
    setShowLoading(true);
    await axios
      .post("portal/messaging/groups/upload.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {selectedRecipient && (
        <Dialog open fullWidth maxWidth="sm">
          <DialogTitle align="center">{selectedRecipient.recipient}</DialogTitle>
          <DialogContent>
            <MDBox>
              <Table>
                {Object.keys(selectedRecipient).map((key) => {
                  if (["recipient", "reference"].includes(key)) {
                    return "";
                  }
                  return (
                    <TableRow>
                      <TableCell>
                        <MDTypography variant="h6">{key}</MDTypography>
                      </TableCell>
                      <TableCell align="right">{selectedRecipient[key]}</TableCell>
                    </TableRow>
                  );
                })}
              </Table>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setSelectedRecipient(null);
              }}
              color="dark"
              variant="outlined"
              iconOnly
            >
              <Icon>close</Icon>
            </MDButton>
          </DialogActions>
        </Dialog>
      )}
      {audienceGroup && (
        <>
          <Dialog open={openUploadAgentsDialog} fullWidth maxWidth="xs">
            <DialogTitle>
              <MDBox>Upload Recipients</MDBox>
            </DialogTitle>
            <DialogContent>
              <MDBox mt={1} mb={3}>
                <MDBox mt={2}>
                  <TextField
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    type="file"
                    name="upload_file"
                    id="upload_file"
                    // onChange={handleFileInputChange}
                    onChange={(e) => fileSelected(e)}
                    fullWidth
                  />
                </MDBox>
                <MDBox mt={3}>
                  <Alert severity="warning">
                    <MDTypography variant="subtitle2" fontSize={14}>
                      <b>Important!</b>
                      <br />
                      Your file must contain{" "}
                      {audienceGroup.messaging_type === "EMAIL" ? (
                        <b>email_address</b>
                      ) : (
                        <b>phone_number</b>
                      )}{" "}
                      column. Other columns will be treated as attributes which can be used to
                      customise your message subject and body.
                    </MDTypography>
                  </Alert>
                </MDBox>
              </MDBox>
            </DialogContent>
            <DialogActions>
              <MDButton
                onClick={() => {
                  setOpenUploadAgentsDialog(false);
                }}
                color="dark"
                variant="outlined"
              >
                Cancel
              </MDButton>
              <MDButton
                color="info"
                variant="outlined"
                onClick={() => {
                  uploadRecipients();
                }}
              >
                Upload
              </MDButton>
            </DialogActions>
          </Dialog>

          <Dialog open={openMessageDialog} fullWidth maxWidth="sm">
            <DialogTitle>
              <MDBox>Send Message</MDBox>
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                <MDBox mb={3}>
                  <MDBox mt={1} mb={3}>
                    <MDInput
                      name="title"
                      margin="dense"
                      label="Message Name"
                      type="text"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </MDBox>
                  {audienceGroup.messaging_type === "EMAIL" ? (
                    <MDBox mt={5}>
                      <MDBox>
                        <Alert severity="info">
                          <MDTypography variant="subtitle2" fontSize={14}>
                            Customise your subject and message body with recipient attributes.
                            Example: {`{{NAME}}, {{INVOICE_NUMBER}}`}
                          </MDTypography>
                        </Alert>
                      </MDBox>
                      <MDBox mt={1}>
                        <MDInput
                          name="title"
                          margin="dense"
                          label="Sender Name"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setSenderName(e.target.value)}
                        />
                      </MDBox>
                      <MDBox mt={2}>
                        <MDInput
                          name="title"
                          margin="dense"
                          label="Email Subject"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setSubject(e.target.value)}
                        />
                      </MDBox>
                      <MDBox mt={3}>
                        <Editor
                          value={messageBody}
                          onChange={(e) => setMessageBody(e.target.value)}
                          placeholder="Email Message Body"
                          minRows={5}
                        />
                      </MDBox>
                    </MDBox>
                  ) : (
                    <MDBox>
                      <MDBox mt={1}>
                        <MDInput
                          multiline
                          minRows={5}
                          label="Message body"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setMessageBody(e.target.value)}
                        />
                      </MDBox>
                      <MDBox mt={3}>
                        <Alert severity="info">
                          <MDTypography variant="subtitle2" fontSize={14}>
                            Customise your message body with recipient attributes. Example:{" "}
                            {`{{NAME}}, {{INVOICE_NUMBER}}`}
                          </MDTypography>
                        </Alert>
                      </MDBox>
                    </MDBox>
                  )}
                  <MDBox mt={3} display="flex" alignItems="center" ml={-1}>
                    <Checkbox
                      checked={scheduled}
                      onChange={(e) => {
                        setScheduled(e.target.checked);
                      }}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                    <MDTypography
                      variant="button"
                      fontWeight="regular"
                      color="text"
                      sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                    >
                      &nbsp;&nbsp;Schedule this message?
                    </MDTypography>
                  </MDBox>
                  {scheduled && (
                    <MDBox mt={4}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={6}>
                          <MDBox mt={-1}>
                            <MDInput
                              name="title"
                              margin="dense"
                              label="Date"
                              type="date"
                              min={`${new Date()?.toISOString()?.slice(0, 10)}`}
                              fullWidth
                              variant="outlined"
                              onChange={(e) => setTriggerDate(e.target.value)}
                            />
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                          <MDBox>
                            <FormControl fullWidth>
                              <InputLabel>Select Time</InputLabel>
                              <Select
                                label="Select Time"
                                onChange={(e) => {
                                  setTriggerTime(e.target.value);
                                }}
                                sx={{ padding: "12px", paddingLeft: "3px" }}
                                value={triggerTime}
                              >
                                <MenuItem value={null}>---</MenuItem>
                                {timeArray.map((row) => (
                                  <MenuItem value={row}>{row}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                  )}
                </MDBox>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <MDButton
                onClick={() => {
                  setOpenMessageDialog(false);
                }}
                color="dark"
                variant="outlined"
              >
                Close
              </MDButton>
              <MDButton
                onClick={() => {
                  sendMessage();
                }}
                color="success"
                variant="outlined"
              >
                {scheduled ? "Schedule" : "Send Now"}
              </MDButton>
            </DialogActions>
          </Dialog>
        </>
      )}
      <MDBox mb={5}>
        <MDBox mt={1} mb={2} display="flex" justifyContent="space-between">
          <MDBox>
            <Button
              color="dark"
              size="small"
              startIcon={<Icon>west</Icon>}
              onClick={() => {
                navigate(`/messaging/groups`);
              }}
            >
              Back
            </Button>
          </MDBox>
        </MDBox>
        {audienceGroup && (
          <MDBox>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox p={0}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center" p={2.5}>
                  <MDBox>
                    <MDTypography variant="h6" fontWeight="light" fontSize={12}>
                      {audienceGroup.messaging_type}
                    </MDTypography>
                    <MDTypography variant="h6" fontWeight="medium">
                      {audienceGroup.title}
                    </MDTypography>
                  </MDBox>
                  <MDBox>
                    <Tooltip title="Send Message">
                      <MDButton
                        variant="outlined"
                        color="dark"
                        iconOnly
                        onClick={() => {
                          if (recipients.length <= 0) {
                            setSeverity("error");
                            setErrMsg("No recipients found. Upload recipients and try again.");
                            setOpen(true);
                            return;
                          }
                          setSenderName(null);
                          setMessageBody(null);
                          setSubject(null);
                          setTitle(null);
                          setOpenMessageDialog(true);
                        }}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>send</Icon>
                      </MDButton>
                    </Tooltip>
                    &nbsp;&nbsp;
                    <Tooltip title="Upload Recipients">
                      <MDButton
                        variant="outlined"
                        color="dark"
                        iconOnly
                        onClick={() => {
                          setOpenUploadAgentsDialog(true);
                        }}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>upload</Icon>
                      </MDButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <MDBox mt={1}>
                  <DataTable
                    table={{ columns: tableColumns, rows: recipients }}
                    isSorted
                    entriesPerPage
                    showTotalEntries
                    noEndBorder
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default RecipientGroupViewPage;
